import _ from 'lodash';

import Upload from 'models/upload';
import { AttachmentType } from 'models/attachment/attachment_classes';

export default {
  toDto(composition) {
    let jso = composition.toJs();
    jso.attachments = _.filter(jso.attachments, a => {
      if (a.type === AttachmentType.UPLOAD) {
        return a.status === Upload.Status.COMPLETED;
      }
      return true;
    });

    return jso;
  },
};



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/composition_converter.js